import { ArrowPathIcon, BellAlertIcon } from "@heroicons/react/24/outline";
import { Button } from "../Control/Button/Button";

export function UpdateAvailable() {
    return (
        <div className="px-8 py-16">
            <div className="flex flex-col items-center">
                <p className="mb-2 text-2xl font-extrabold text-contrast-secondary">Site Update Available!</p>
                <p className="mb-4">Please refresh page.</p>
                <Button title="Refresh" className="!p-4" color="emphasis" onClick={() => window.location.reload()}>
                    <ArrowPathIcon className="h-5 w-5" />
                </Button>
            </div>
        </div>
    )
}